export default __webpack_public_path__ + "static/media/toggle_off.6fca9bc1.svg";